export default __webpack_public_path__ + "static/media/0389.72c64174.jpg";